/** 加载中 */
export const showLoading = ()=>{
  if(global.vm) {
    global.vm.$Spin.show({
      render: (h) => {
        return h('div', [
          h('Icon', {
            'class': 'demo-spin-icon-load',
            props: {
              type: 'ios-loading',
              color:'#fff',
              size: 30
            }
          }),
          h('div', {
            style:{
              color:'#fff',
              marginTop:'8px',
              fontSize:'18px'
            }
          },'加载中')
        ])
      }
    });
  }
}

/** 关闭加载页面 */
export const dismissLoading = ()=>{
  if(global.vm) {
    global.vm.$Spin.hide();
  }
}



// WEBPACK FOOTER //
// ./src/libs/LoadingUtil.js